<template>
    <div class="spinner" :style="style" :class="size">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</template>

<script>
export default {
    props:{
        size:{
            type: String,
            default: 'big'
        },
        opacity: {
            type: String,
            default: "1"
        }
    },
    computed:{
        style () {
            return 'opacity: '+ this.opacity;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

/*Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */


.spinner {
    text-align: center;
    display: inline-block;
    min-height: 1em;

    div {
        background-color: $dark;

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    &.big{
        width: 70px;
        div{
            width: 12px;
            height: 12px;
        }
    }

    &.small{
        width: 35px;
        div{
            width: 6px;
            height: 6px;
        }
    }

    .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }
}

@-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
    0%, 80%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}
</style>



// WEBPACK FOOTER //
// loader1.vue?47bca0e4